import React from 'react';

/**
 * 进度环
 * @param progress 进度百分比 0-1
 */
export const CircleProgress = ({progress}: {progress: number}) => {
    const percent = progress, perimeter = Math.PI * 2 * 170;
    const dasharray = perimeter * percent + " 1069"
    return (
        <svg width="440" height="440" viewBox="0 0 440 440" className='circle-progress'>
            <circle cx="220" cy="220" r="170" strokeWidth="50" stroke="#e0e0e0" fill="none"></circle>
            <circle cx="220" strokeDasharray={dasharray} cy="220" r="170" strokeWidth="50" stroke="#5aa7b4" fill="none" transform="matrix(0,-1,1,0,0,440)"></circle>
        </svg>
    );
};
